import { configureStore } from "@reduxjs/toolkit";

import studentReducer from "./slices/studentSlice";
import translationReducer from "./slices/translationSlice";
import errorReducer from "./slices/errorSlice";
import courseReducer from "./slices/courseSlice";
import activityReducer from "./slices/activitySlice";
import settingReducer from "./slices/settingSlice";

const toolkitReducers = {
  student: studentReducer,
  translation: translationReducer,
  error: errorReducer,
  activity: activityReducer,
  course: courseReducer,
  setting: settingReducer,
};
const store = configureStore({
  reducer: toolkitReducers,
});
export default store;
